window.center_text_v = (obj,nh)->
  h = obj.height()
  mt = Math.ceil((h-nh)/2)
  mt = mt*-1
  mt1 = mt+'px'
  obj.css 'paddingTop': mt1
  obj.css 'paddingBottom' : mt1

getTitleVideo = ->
  TitleVideo = $('#desc-boxVideo p strong').text()
  $('#wrap-video h2.title').text TitleVideo

SizeVideo = ->
  $('#boxVideo div object, #boxVideo div embed').attr('height','366').attr('width','600')
  getTitleVideo()

showRanking = (id)->
  $('#team-ranking-home').children().hide()
  showRank = $('#team-'+id).attr('rel')
  $(showRank).show()
  $('#list-teams-home li').addClass('fg2')
  $('#list-teams-home li').removeClass('selected')
  $('#team-'+id).removeClass('fg2')
  $('#team-'+id).addClass('selected')

carouselHeader = (startPoint,nLi)->
  $('#matches-header').jcarousel
    vertical: false
    animation: 500
    scroll: 1
    start: parseInt(startPoint,10)
  # $('#box-matches-header .jcarousel-container-horizontal').addClass('jcarousel-header')
  wUl = nLi*126
  $('#matches-header').css('width',wUl+'px')

carouselTeam = (startPoint,nLi)->
  $('#matches-team').jcarousel
    vertical: false
    animation: 500
    scroll: 1
    start: parseInt(startPoint,10)
  # $('#box-matches-team .jcarousel-container-horizontal').addClass('jcarousel-team')
  wUl = nLi*138
  $('#matches-team').css('width',wUl+'px')

getGameInfo = (path,m_id)->
  initialize = ""
  $('#gameInfoBox').html("").dialog("destroy")
  $('#gameInfoBox').load path+'/matches_page.php?m_id='+m_id, ->
    $('#gameInfoBox').dialog
      modal: true
      open: initialize
      width: 1032
      height: 500
      show: "fade"
      hide: "fade"
    $('#map_wrapper').addClass('bg-color2')

centerTextSearchPhoto = ->
  $('#search-result #albums .box-last-photogallery').each ->
    textPhotoAlbum = $(@).children('.desc').find('p')
    center_text_v(textPhotoAlbum, 42)
  $('#search-result #multimedia-files .box-last-photogallery').each ->
    textPhoto = $(@).children('.desc').find('p')
    center_text_v(textPhoto, 42)

centerTextSearchVideo = ->
  $('#box-albums-video #albums .box-album-video').each ->
    textVideoAlbum = $(@).children('.desc-album-videogallery').find('p')
    center_text_v(textVideoAlbum, 42)
  $('#box-albums-video #multimedia-files .box-album-video').each ->
    textVideo = $(@).children('.desc-album-videogallery').find('p')
    center_text_v(textVideo, 42)

callbackSlideshow = ->
  $('.nav-slideshow-top a, .nav-slideshow-bottom li').removeClass('activeSlide')
  $('#featured-slideshow').children().each ->
    if $(@).css('opacity')==1
      nSlide = $(@).data().iterator
      $('.slide-'+nSlide).addClass("activeSlide")
      title = $(@).find('img').attr('alt')
      link = $(@).find('img').data().href
      $('.featured-entry strong').text(title)
      $('.featured-entry .read-all a').attr('href', link)

$ ->
  if($('#box-matches-header').length > 0)
    space_available = $('#bar_share_container').height() -
      $('#box-matches-header').height()
    top = (space_available / 2) - $('#share-header').height()
    if(top > 0)
      $('#box-matches-header').css('top',top)

  $("#content.home > div:nth-child(2n+1)").addClass "odd"

  slideshow() if $('#slideshow').length > 0

  $('#games-bar').jcarousel
    vertical: false
    animation: 500
    scroll: 1

  $('#matches-bar').jcarousel
    vertical: false
    animation: 500
    scroll: 1

  events_all_page = $('.events-all-page')
  if events_all_page.length > 0
    data_json = $('#carousel-events').data().data_json
    argsCarouselEvents = new Array(3)
    argsCarouselEvents.vertical = true
    argsCarouselEvents.scroll = 1
    selectedClass = data_json.selectedClass
    normalClass = data_json.normalClass
    carouselEventsAll(data_json.startPoint, argsCarouselEvents)

  contact_page_template = $('.contact-page-template')
  if contact_page_template.length > 0
    $(".contact-page-template-avatarbox").click ->
      contact_id = $(@).data().openbox
      open_box(contact_id) if contact_id

  $('.nav-slideshow-bottom').jcarousel
    vertical: false
    animation: 500
    scroll: 1
    start: parseInt(1,10)
  $('#box-thumb-slideshow .jcarousel-container-horizontal').addClass('jcarousel-slideshow').addClass('bg-tit')

  $('#arrow-slide-bottom').on "click", ->
    $('#box-thumb-slideshow').toggleClass('giu')
    $(@).toggleClass('giu')

  SizeVideo()

  $('#nav #nav-content ul.sf-menu > li > a').addClass('fg2').addClass('br-color')
  $('.quick-nav a').addClass('fg2')
  $('#nav #nav-content ul.sf-menu li ul.children, #nav #nav-content ul.quick-nav .login-box').addClass('bg-color2')
  $('#nav #nav-content ul.sf-menu li ul li a').addClass('br-color3').addClass('fg')
  $('#nav #nav-content ul.quick-nav .login-box #btn-submit-login').addClass('bg-color3')

  $('.single-page .left-col .entry-content #respond a, .game-page .entry-content #respond a').addClass('fg3')

  $('.archive-page .navigation a').addClass('fg2')

  $('.error404 .single-post').addClass('br-color')

  $('#box-news-notice').tabs()

  $('.right-col-team-page').tabs()

  $(".fancybox-last-video-home").fancybox
    'type': "iframe"
    'autoDimension': true
    'showCloseButton': true
    'autoScale': true
    'frameWidth': 622
    'frameHeight': 374
    'hideOnContentClick': false
    'overlayColor': '#000'
    'overlayOpacity': '0.7'

  $('#list-teams-home').jcarousel
    vertical: true
    animation: 500
    scroll: 1
  # $('#rankings .jcarousel-container-vertical').addClass('jcarousel-list-team-home')

  $('#list-article-single').jcarousel
    vertical: true
    animation: 500
    scroll: 1
  # $('.single-page .right-col .jcarousel-container-vertical').addClass('jcarousel-list-article-single')

  $('#list-events').jcarousel
    vertical: true
    animation: 500
    scroll: 1
  # $('.events-page .right-col .jcarousel-container-vertical').addClass('jcarousel-list-events')

  $('#list-products-shop').jcarousel
    vertical: true
    animation: 500
    scroll: 1
  $('.shop-page .jcarousel-container-vertical').addClass('jcarousel-list-products-shop')

  $('#list-products-shop-right').jcarousel
    vertical: true
    animation: 500
    scroll: 1
    itemFallbackDimension: 66
  # $('.shop-page-details .jcarousel-container-vertical').addClass('jcarousel-list-products-shop-details')

  $('#albums-video').jcarousel
    vertical: true
    animation: 500
    scroll: 1
  # $('#box-albums-video .jcarousel-container-vertical').addClass('jcarousel-albums-video')

  $('#related-videos').jcarousel
    vertical: true
    animation: 500
    scroll: 1
  # $('#box-related-videos .jcarousel-container-vertical').addClass('jcarousel-related-videos').addClass('jcarousel-list-article-single')

  $('#photos-first-step').jcarousel
    vertical: true
    animation: 500
    scroll: 1
  # $('#box-photos-first-step .jcarousel-container-vertical').addClass('jcarousel-albums-video').addClass('jcarousel-albums-photo')

  # $('#box-albums-photo .jcarousel-container-vertical').addClass('jcarousel-albums-video').addClass('jcarousel-albums-photo').addClass('jcarousel-albums-photo-big');

  $('#albums-single-photo').jcarousel
    vertical: false
    animation: 500
    scroll: 1
  # $('#box-albums-single-photo .jcarousel-container-horizontal').addClass('jcarousel-albums-single-photo')

  $('.ul-sponsor').each ->
    nLi = $(@).find('li').length
    if nLi > 1
      $(@).jcarousel
        vertical: false
        animation: 2000
        scroll: 1
        auto: 5
        wrap: "circular"
    else
      $(@).jcarousel
        vertical: false
        animation: 2000
        scroll: 1

  $('.contacts-page .contacts-group').each ->
    $(@).find('div.contact').each ->
      linkMail = $(@).find('a')
      if linkMail.attr('class') == "right-contact"
        linkMail.find('img[class^=mail]').css('left','-14px')
        linkMail.find('img[class^=mail]').mouseover ->
          $(@).css('left','-23px')
        linkMail.find('img[class^=mail]').mouseout ->
          $(@).css('left','-14px')

  $('#list-products-shop li').each ->
    infoProduct = $(@).children('.box-shop-desc')
    center_text_v(infoProduct, 104)

  center_text_v($('#box-article-details #box-info-article-details'), 264)

  $('.team-page .entry-content .team-roster > li .list-player li').each ->
    infoPlayer = $(@).children('.roster-player')
    center_text_v(infoPlayer, 60)

  $('#albums-video li .box-album-video, #albums-photo li .box-album-photo, #latest-photos .box-last-photogallery, #photos-first-step li .box-album-photo').each ->
    textAlbumVideo = $(@).find('p')
    center_text_v(textAlbumVideo, 42)

  $('.jcarousel-albums-single-photo .jcarousel-item-horizontal').each ->
    textAlbumPhoto = $(@).find('p')
    center_text_v(textAlbumPhoto,42)

  $('.post-group').each ->
    text = $(@).children('.info').find('p')
    center_text_v(text, 62)

  $('#list-events li').each ->
    text2 = $(@).children('.info-article').find('p')
    center_text_v(text2, 62)

  $('#result-last-match .box-statistics div.box-rank').hover ->
    $(@).toggleClass('hover')
    $(@).parent().toggleClass('hover')

  $('#box-white-sponsors a').each ->
    $(@).attr('target','_blank')
    $(@).removeClass('fancybox')
    center_text_v($(@).find('img'), 50)

  $('.standard-page .entry-content .desc-page table, .standard-page .entry-content .desc-page table td').addClass('br-color')

  $('.game-page .game-page-right #box-last-match .read-all').on "click", (event)->
    event.preventDefault()
    $('.game-page .entry-content').children().toggle()

  jCarouselAutoInit('#matches-header',{
    vertical: false,
    animation: 500,
    scroll: 1
  });

  jCarouselAutoInit('#matches-team',{
    vertical: false,
    animation: 500,
    scroll: 1
  });

  $('#privacy-policy h3').addClass('box-title bg-tit fg2')

$(window).load ->
  SizeVideo()

  $('#list-products-shop li').each ->
    infoProduct = $(@).children('.box-shop-desc')
    center_text_v(infoProduct, 104)

# Customizer
$ ->
  if typeof wp != "undefined" and wp.customize
    wp.customize "header", (value)->
      value.bind (newval)->
        if newval==""
          $("#img-header").hide()
        else
          $("#img-header").attr('src', newval)
          $("#img-header").show()

  window.box_background_color_backend = (newval)->
    _style = "\
      background: -moz-linear-gradient(top, " + newval + " 0%, #ffffff 100%);\
      background: -webkit-gradient(linear, left top, left bottom, color-stop(0%," + newval + "), color-stop(100%,#ffffff));\
      background: -webkit-linear-gradient(top, " + newval + " 0%,#ffffff 100%);\
      background: -o-linear-gradient(top, " + newval + " 0%,#ffffff 100%);\
      background: -ms-linear-gradient(top, " + newval + " 0%,#ffffff 100%);\
      background: linear-gradient(to bottom, " + newval + " 0%,#ffffff 100%);\
      filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='" + newval + "', endColorstr='#ffffff',GradientType=0 );"
    _style = ".bg-grad { " + _style + " }"
    return _style;